import apiWrapper from 'Helpers/apiWrapper'

import type { EngagementItem, RecipientIds } from 'Types/beEngagementApi'

const endpoints = ((baseURL) => {
  return {
    getEngagement: (idList: number) =>
      `${baseURL}/api/list/${idList}/engagement`,
  }
})(process.env.BEENGAGEMENT_URL as string)

export const beEngagementApiGetEngagement = async (
  idList: number,
  data: RecipientIds,
): Promise<EngagementItem[]> => {
  return await apiWrapper({
    method: 'post',
    url: endpoints.getEngagement(idList),
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(data),
  }).then(({ data }) => data)
}
